<div class="container">
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-5">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1">
          <h3 class="misc-titles text-center">Login</h3>
          <div class="container" style="border:1px solid #bebaba">
            <p class="misc-titles text-center">
              <br />To submit an online claim please enter the Unique ID and PIN provided to you on your Notice.
            </p>
            <div class="form-group">
              <label for="uniqueId" style="font-weight:bold">Unique Id: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="uniqueId" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.uniqueId.errors }" />
              <div *ngIf="submitted && f.uniqueId.errors" class="invalid-feedback">
                <div *ngIf="f.uniqueId.errors.required">This field is required</div>
                <div *ngIf="f.uniqueId.errors.minlength">This field must be at least 8 characters</div>
                <div *ngIf="f.uniqueId.errors.maxlength">
                  This field must not be greater than 8 characters
                </div>
                <div *ngIf="f.uniqueId.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>
            <div class="form-group">
              <label for="pin" style="font-weight:bold">Pin: <span style="color:red" class="required"> *</span></label>
              <input type="text" class="form-control" formControlName="pin" trim="blur" autocomplete="off"
                     [ngClass]="{ 'is-invalid': submitted && f.pin.errors }" />
              <div *ngIf="submitted && f.pin.errors" class="invalid-feedback">
                <div *ngIf="f.pin.errors.required">This field is required</div>
                <div *ngIf="f.pin.errors.minlength">This field must be at least 6 characters</div>
                <div *ngIf="f.pin.errors.maxlength">
                  This field must not be greater than 6 characters
                </div>
                <div *ngIf="f.pin.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
              </div>
            </div>

            <br />
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="form-group">
                  <button class="btn btn-primary" id="login" [disabled]="clicked">Login</button>
                </div>
              </div>
            </div>
            <br />
            <!--<p class="misc-titles text-center">
              If you did not receive a Notice or cannot locate your Unique ID and PIN, please click the button below
            </p>
            <div class="row">
              <div class="col-md-12 text-center">
                <a href="/file" class="btn btn-primary">Don't have a Unique Id and PIN? Click Here.</a>
              </div>
            </div>-->
            <br />
          </div>
          <br />
        </div>

        <div class="col-md-3"></div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <div class="row mt-3" *ngIf="showDivHasFiled == true">
      <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
        This Unique Id and Pin have already been used. Please contact <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a> for questions.
      </div>
    </div>
  </div>
</div>
